import styled from "styled-components";
import { shimmer } from "../../../../keyframes/FadeIn";

export const TournamentStateWrapper = styled.div<{
  isApp: null | number;
  reservation: boolean;
}>`
  position: relative;
  height: 100%;
  background: white;
  overflow-x: hidden;
`;

export const TournamentStateContentsWrapper = styled.div<{
  inset: null | number;
}>`
  margin-top: ${(p) => (p.inset ? p.inset + 58 : 58)}px;

  > .content {
    position: relative;
  }
`;

export const TournamentStateHeader = styled.div<{ isApp: null | number }>`
  z-index: 101;
  transition: all 0.1s ease-in-out;
  top: 0;
  position: fixed;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  gap: 8px;
  background-color: white;
  padding-top: ${(p) => (p.isApp ? `${p.isApp + 12}px` : "0")};
  padding-bottom: ${(p) => (p.isApp ? `${24}px` : "0")};
  .close {
    cursor: pointer;
    width: 24px;
    height: 24px;

    svg path {
      stroke: var(--Black-400, #444);
    }
  }

  .title {
    font-weight: 600;
    font-size: 16px;
  }
`;

export const TournamentBackgroundImage = styled.div`
  width: 100%;
  height: 324px;
  overflow: hidden;
  > img {
    width: 100%;
    object-fit: cover;
  }
`;

export const TournamentContent = styled.div<{ isReservation: boolean }>`
  position: absolute;
  top: ${(p) => (p.isReservation ? "-83px" : 0)};
  width: 100%;
  padding-bottom: 100px;
`;

export const TournamentStateSkeleton = styled.div`
  ${shimmer}
  width: 100%;
  height: 100px;
  border-radius: 12px;
  margin-top: 12px;
`;
